import { RouteObject } from 'react-router';
// import LoginPage from './pages/login';
import OAuthPage from './pages/oauth';
import SignInPage from './pages/signin';

export const routes: RouteObject[] = [
  {
    path: 'login',
    element: <SignInPage />,
  },
  {
    path: 'oauth',
    element: <OAuthPage />,
  },
  {
    path: 'access',
    element: <SignInPage />,
  },
];
